import React from "react"

import Board_Manager from "../../../../../gd-modules/tasks-view/board/managers/manager"
import FieldProto from "../../../../proto/field-proto"
import Board_AggregateShell from "../../../../../gd-modules/tasks-view/board/components/aggregate/aggregate-shell"
import FieldRating from "../../rating";
import FieldRating_EditableStateful from "../editable/rating-component";

type Props = {
    className       : string

    manager         : Board_Manager
    field           : FieldProto

    calculatedData  : {
        own             : {
            value: number
        }
        children        : {
            value: number
        }
        total           : {
            value: number
        }

        hasOwnValue     : boolean
        hasChildren     : boolean
    }
}

// const debug = "FieldRating_BoardAggregate"
const debug = false

export default function FieldRating_BoardAggregate(props: Props) {

    const value     = props.calculatedData?.total.value
    const isValid   = !_.isNil(value) && !_.isNaN(value)

    debug && console.log(debug, 'render', isValid, value, props.calculatedData)

    const showSelector = isValid && !!value
    const classes = Classes("left-aligned flex-no-shrink max-w-130", props.className, {
        'show-on-hover': !showSelector
    })

    return (
        <Board_AggregateShell
            className   = {classes}
            manager     = {props.manager}
        >
            {!showSelector &&
                <div className="flex-row-left-center">
                    <div className={Classes("ui5-ico-12 m-r-5 m-t-1", props.field.icon)}/>
                </div>}

            {showSelector &&
                <div className="flex-row-left-center txt-truncate">
                    <FieldRating_EditableStateful
                        field       = {props.field as FieldRating}
                        value       = {value}
                        disabled    = {true}
                    />
                </div>}
        </Board_AggregateShell>
    )
}
